import { Box, Stack, Typography } from '@mui/material';
import { type S3AssetLike } from './ContentItemEditor.types';

// The height an image renders at, and the side of the square that stands in for a missing one.
const IMAGE_SIZE = 150;

type Props = {
    image: S3AssetLike | null | undefined;
    alt: string;

    // Half faded, which is how a course that is coming soon showed its image in the Angular page.
    faded?: boolean;
};

/*
    The image of a content item, or a placeholder the same size when it has none.

    The placeholder is a square rather than a line of text. As text the column collapsed, which left
    the upload button alone at the foot of an empty column and moved it every time an image was
    added or removed.
*/
export default function ContentItemImagePreview({ image, alt, faded = false }: Props) {
    if (image) {
        return (
            <Box
                component="img"
                src={image.formats.original.url}
                alt={alt}
                sx={{ height: IMAGE_SIZE, maxWidth: '100%', opacity: faded ? 0.5 : 1 }}
            />
        );
    }

    return (
        <Stack
            sx={{
                width: IMAGE_SIZE,
                height: IMAGE_SIZE,
                flexShrink: 0,
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px dashed',
                borderColor: 'divider',
                borderRadius: 1,
                padding: 1,
            }}
        >
            <Typography variant="body2" color="text.secondary" align="center">
                No Image Uploaded
            </Typography>
        </Stack>
    );
}
